import CustomizeTransitionProperties from "../../../../partials/customizing/transition-properties.mdx";
import * as React from 'react';
export default {
  CustomizeTransitionProperties,
  React
};